import React from "react";

interface ImageItem {
  url: string;
  title: string;
  description: string;
}

interface GalleryProps {
  images: ImageItem[];
  onImageClick: (index: number) => void;
}

const GalleryContainer: React.FC<GalleryProps> = ({ images, onImageClick }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
      {images.map((item, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-xl aspect-square shadow-md hover:scale-110 transition-transform duration-300 cursor-pointer"
          onClick={() => onImageClick(index)}
        >
          <img
            src={item.url}
            alt={`image-${index}`}
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  );
};

export default GalleryContainer;
